import { useContext, useState, useLayoutEffect, useEffect, useRef, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { isEqual } from "lodash";

import { Grid, MenuItem, Select, Typography, TextField, Divider, useMediaQuery, Menu, CircularProgress } from "@mui/material";
import TuneIcon from '@mui/icons-material/Tune';
import ArrowBack from '@mui/icons-material/ArrowBack';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import globalStyles from "../../../../assets/styles/global.module.scss";
import styles from "../../../../assets/styles/componentStyles/templateLibraryStyles/modifyWhatsAppTemplate/modifyWhatsAppTemplate.module.scss";

import agent from "../../../../services/api";
import GlobalButton from "../../../utility/globalButton/button";

import { whatsappTemplateLanguages } from "../../../../utils/whatsappTemplate";
import { areBodyVariablesModified, areHeaderVariablesModified, defaultButtonTextForListType, doesBodyTextStartOrEndWithVariable, doesCarouselMessageBodyTextStartOrEndWithVariable, getTemplateCategoryId, getValidationsFromInteractiveType, isBasicTemplate, isCallPermissionRequestTemplate, isCarouselTemplate, isCatalogTemplate, isInteractiveTypeMessageFlow, isInteractiveTypeMessageList, isInteractiveTypeNameList, isTemplateCategoryAuthentication, TEMPLATE_CATEGORY, TEMPLATE_TYPES, WHATSAPP_TEMPLATE_STATUS } from "../../channels/global/whatsapp/templates/utils";
import { createWhatsappTemplateBody, createWhatsappTemplateFooter, createWhatsappTemplateHeader, createWhatsappTemplatePayload, createWhatsappTemplatePayloadForTemplateLibrary, getWhatsappTemplateTypeResponse, interactiveType } from "../../../../models/axiosModel";
import { useTemplateLibraryStore } from "../../../../store/templateLibraryStore";
import { UserContext, UserContextPayload } from "../../../../context/userContext";
import { checkFlagError, isFlowButton, TEMPLATE_NAME_MAX_CHARS_MESSAGE, TEMPLATE_NAME_MAX_LIMIT, createAuthenticationTemplateFromScratch, createBasicTemplateFromScratch, getTemplateTypeIdByName, createCarouselTemplateFromScratch, createCatalogTemplateFromScratch, createInteractiveTemplateFromScratch, normalizeTemplatePayloadForDraft, isInteractiveTemplate, isTemplateCreated, isInvalidUrl, TEMPLATE_NAME_REGEX, doesCreateTemplateBodyHaveInvalidFormatting, hasConsecutiveNewlinesInCarouselBody, createCallPermissionRequestTemplateFromScratch, hasDuplicateButtonText, LOCATION_HEADER_FIELDS, isValidLatitudeValue, isValidLongitudeValue } from "../constant";
import { IntegrationContext, IntegrationContextPayload } from "../../../../context/integrationContext";
import { formatString, isValidWabaId } from "../../../../utils/constants";

import GlobalPopUp from "../../../utility/globalPopUp";
import UnsavedChangesPopup from "../utils/UnsavedChangesPopup";
import ConnectWabaPopup from "../utils/ConnectWabaPopup";
import ImportTemplatePopup from "../utils/importTemplatePopup";
import PostCreateTemplatePopup from "../utils/PostCreateTemplatePopup";
import { useCarouselFunctions } from "../utils/useCarouselFunctions";
import TouchTooltip from "../utils/TouchTooltip";
import { useGenericStore } from "../../../../store/genericStore";
import { useShallow } from "zustand/react/shallow";
import useIsTruncated from "../../../../hooks/useIsTruncated";

const ModifyWhatsAppTemplateHeader = (props: any) => {
    
    const { 
        checkTypeOfVariableValidation, setHasUnsavedChanges, initialPayloadRef, carouselFiles, carouselInvalidId,
        setCarouselFiles, setCarouselInvalidId, removeUploadedFile, getFlowListApi, publishedFlowList, getInteractiveTypeList
    } = props;

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    let id = searchParams.get('id');
    let draft_id = searchParams.get('draft_id');
    let template_id = searchParams.get('template_id');

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
        flagLaptopScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1536px)'),
    }

    const isCompactPopup = breakPoints.smallScreen || breakPoints.flagTabletScreen;
    const popupPaperMinWidth = isCompactPopup ? "310px" : "600px";
    const popupPaperMaxWidth = isCompactPopup ? "610px" : "650px";
    
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { integrationListNewStructure } = useContext(IntegrationContext) as IntegrationContextPayload;

    const formOpen = useTemplateLibraryStore((state) => state.modifyTemplate.formOpen);
    const setFormOpen = useTemplateLibraryStore((state) => state.modifyTemplate.setFormOpen);
    const hoverEditTemplateName = useTemplateLibraryStore((state) => state.modifyTemplate.hoverEditTemplateName);
    const setHoverEditTemplateName = useTemplateLibraryStore((state) => state.modifyTemplate.setHoverEditTemplateName);

    const createTemplatePayload = useTemplateLibraryStore((state) => state.createTemplatePayload);
    const whatsappTemplateDynamicVarTypes = useTemplateLibraryStore((state) => state.whatsappTemplateDynamicVarTypes);
    const existingTemplateData = useTemplateLibraryStore((state) => state.existingTemplateData);
    const setCreateTemplatePayload = useTemplateLibraryStore((state) => state.setCreateTemplatePayload);
    const setExistingTemplateData = useTemplateLibraryStore((state) => state.setExistingTemplateData);
    const setExistingPayloadData = useTemplateLibraryStore((state) => state.setExistingPayloadData);
    const whatsappTemplateTypes = useTemplateLibraryStore((state) => state.whatsappTemplateTypes);
    const interactiveTypeList = useTemplateLibraryStore((state) => state.interactiveTypeList);
    const getInteractiveTypeListApiCall = useTemplateLibraryStore((state) => state.getInteractiveTypeListApiCall);
    const inValidId = useTemplateLibraryStore((state) => state.inValidId) ?? [];
    const invalidPayloadObjectId = useTemplateLibraryStore((state) => state.invalidPayloadObjectId) ?? [];
    const whatsappTemplateButtonGenericData = useTemplateLibraryStore((state) => state.whatsappTemplateButtonGenericData);
    const files = useTemplateLibraryStore((state) => state.files) ?? [];
    const setFiles = useTemplateLibraryStore((state) => state.setFiles);
    const existingHeaderTemplateVariableData = useTemplateLibraryStore((state) => state.existingHeaderTemplateVariableData);
    const setExistingHeaderTemplateVariableData = useTemplateLibraryStore((state) => state.setExistingHeaderTemplateVariableData);
    const whatsappTemplateHeaderTypes = useTemplateLibraryStore((state) => state.whatsappTemplateHeaderTypes);
    const templateLibraryCategoryList = useTemplateLibraryStore((state) => state.templateLibraryCategoryList);
    const hasUnsavedChanges = useTemplateLibraryStore((state) => state.hasUnsavedChanges);

    const showUnsavedChangesModal = useTemplateLibraryStore((state) => state.showUnsavedChangesModal);
    const setShowUnsavedChangesModal = useTemplateLibraryStore((state) => state.setShowUnsavedChangesModal);

    const showConnectWabaModal = useTemplateLibraryStore((state) => state.showConnectWabaModal);
    const setShowConnectWabaModal = useTemplateLibraryStore((state) => state.setShowConnectWabaModal);

    const createDraftTemplate = useTemplateLibraryStore((state) => state.createDraftTemplate);
    const deleteDraftTemplate = useTemplateLibraryStore((state) => state.deleteDraftTemplate);
    const setTemplateStatus = useTemplateLibraryStore((state) => state.setTemplateStatus);

    const showImportTemplatePopup = useTemplateLibraryStore((state) => state.showImportTemplatePopup);
    const setShowImportTemplatePopup = useTemplateLibraryStore((state) => state.setShowImportTemplatePopup);

    const postCreatePopup = useTemplateLibraryStore((state) => state.postCreatePopup);
    const closePostSubmitPopup = useTemplateLibraryStore((state) => state.closePostSubmitPopup);
    const openPostSubmitPopup = useTemplateLibraryStore((state) => state.openPostSubmitPopup);

    const isAuthenticationTemplate = isTemplateCategoryAuthentication(templateLibraryCategoryList, createTemplatePayload?.whatsapp_template_data?.whatsapp_template_category_id);
    const existingPayloadKey = useTemplateLibraryStore((state) => state.existingPayloadKey) ?? [];

    const templateStatus = useTemplateLibraryStore((state) => state.templateStatus);

    const { showInfo, showSuccess } = useGenericStore(useShallow((state) => ({
        showInfo: state.showInfo,
        showSuccess: state.showSuccess
    })))

    const { 
        checkFlagErrorCarousel, checkBodyValueVariableCard, checkButtonVariableCard, checkHeaderCard, checkBodyValueCards, 
        checkBodyVariableCard, checkButtonLengthCard, checkIfHeaderDataIsFillOrNotCarousel, isMobileScreen, isScreenBelow1250, isScreenBelow1000
    } = useCarouselFunctions();

    const previousPayloadRef = useRef<createWhatsappTemplatePayloadForTemplateLibrary | null>(null);

    const [anchorEl, setAnchorEl] = useState<null | Element>(null);
    
    const [isSavingDraft, setIsSavingDraft] = useState(false);

    // Constants
    const isTemplateTypeCatalog = isCatalogTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id);
    const isTemplateTypeCallPermissionRequest = isCallPermissionRequestTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id);

    const templateName = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_display_name ?? createTemplatePayload?.whatsapp_template_data?.whatsapp_template_name;
    const { ref: templateNameRef, isTruncated: isTemplateNameTruncated } = useIsTruncated([templateName, hoverEditTemplateName]);

    const isCategorySelectionDisabled = isTemplateCreated(createTemplatePayload) 
        || isCarouselTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id)
        || isTemplateTypeCatalog;

    // Menu Item Functions
    const isCreateMenuItemActive = (templateType?: string) => {
        if (!templateType) {
            return false;
        }

        const typeId = createTemplatePayload?.whatsapp_template_type_id;

        switch (templateType) {
            case "Interactive":
                return !!createTemplatePayload?.whatsapp_template_flag_interactive_message;
            case TEMPLATE_TYPES['BASIC']:
                return !createTemplatePayload?.whatsapp_template_flag_interactive_message && isBasicTemplate(whatsappTemplateTypes, typeId);
            case TEMPLATE_TYPES['CATALOG']:
                return  isCatalogTemplate(whatsappTemplateTypes, typeId);
            case TEMPLATE_TYPES['CAROUSEL']:
                return isCarouselTemplate(whatsappTemplateTypes, typeId);
            case TEMPLATE_TYPES['CALL_PERMISSION_REQUEST']:
                return isCallPermissionRequestTemplate(whatsappTemplateTypes, typeId);
            default:
                return false;
        }
    };

    const menuItems: { label: string; templateType?: string; action: () => void; disable?: boolean }[] = [
        {
            label: "Create Basic Template",
            templateType: TEMPLATE_TYPES['BASIC'],
            action: () => { handleTemplateTypeChange(getTemplateTypeIdByName(whatsappTemplateTypes, TEMPLATE_TYPES['BASIC'])); }
        },
        {
            label: "Create Catalog Template",
            templateType: TEMPLATE_TYPES['CATALOG'],
            action: () => { handleTemplateTypeChange(getTemplateTypeIdByName(whatsappTemplateTypes, TEMPLATE_TYPES['CATALOG'])); }
        },
        {
            label: "Create Carousel Template",
            templateType: TEMPLATE_TYPES['CAROUSEL'],
            action: () => { handleTemplateTypeChange(getTemplateTypeIdByName(whatsappTemplateTypes, TEMPLATE_TYPES['CAROUSEL'])); }
        },
        {
            label: "Create Interactive Template",
            templateType: "Interactive",
            action: () => { onChangeOfInteractiveMessageSwitch(true); }
        },
        {
            label: "Create Call Permission Template",
            templateType: TEMPLATE_TYPES['CALL_PERMISSION_REQUEST'],
            action: () => { handleTemplateTypeChange(getTemplateTypeIdByName(whatsappTemplateTypes, TEMPLATE_TYPES['CALL_PERMISSION_REQUEST'])); }
        },
        {
            label: "Import Template",
            action: () => { setShowImportTemplatePopup(true); }
        }
    ]

    if(isScreenBelow1250 && !template_id){
        menuItems.push({
            label: "Save Draft",
            action: () => { handleSaveDraft() },
            disable: isSavingDraft,
        });
    }

    
    // Menu Functions
    const handleMenuOpen = (event: React.MouseEvent<Element>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    }

    const handleMenuClose = () => {
        setAnchorEl(null);
    }

    const handleMenuClick = (action: () => void) => {
        handleMenuClose();
        action();
    }
    
    // Unsaved Changes Modal Functions
    const openUnsavedChangesModal = () => {
        setShowUnsavedChangesModal(true);
    }
    
    const closeUnsavedChangesModal = () => {
        setShowUnsavedChangesModal(false);
    }

    // Confirm Leave Page Functions
    const confirmLeavePage = () => {
        setShowUnsavedChangesModal(false);
        window.history.length > 1 ? window.history.back() : navigate(`/channels/viewintegration/whatsapp/templatemessages?id=${id}`);
    };

    const confirmSaveAndLeave = async () => {
        await handleSaveDraft();
        setShowUnsavedChangesModal(false);
        navigate(`/channels/viewintegration/whatsapp/templatemessages?id=${id}`);
    }

    const handleBackButtonClick = () => {
        if(hasUnsavedChanges && !createTemplatePayload?.whatsapp_template_id) {
            openUnsavedChangesModal();
        } 
        else if(window.history.length > 1) {
            window.history.back();
        } 
        else {
            navigate(`/channels/viewintegration/whatsapp/templatemessages?id=${id}`);
        }
    }

    const hasNoTemplateName = () => {
        return createTemplatePayload?.whatsapp_template_data?.whatsapp_template_display_name?.trim()?.length === 0;
    }

    const shouldShowTemplateStatus = useMemo(() => {
        return !!(template_id || draft_id);
    }, [template_id, draft_id]);

    const getStatusChipStyle = () => {
        const status = templateStatus?.toLowerCase() ?? '';
        
        switch(status) {
            case "approved":
                return globalStyles.approvedButtonStyle;
            case "pending":
                return globalStyles.pendingButtonStyle;
            case "rejected":
                return globalStyles.rejectedButtonStyle;
            default:
                return globalStyles.draftButtonStyle;
        }
    }

    const syncTemplateStatusAfterSubmit = (
        submittedPayload: createWhatsappTemplatePayloadForTemplateLibrary,
        responseData?: { whatsapp_template_metadata?: { meta_whatsapp_template_status_name?: string | null } } | null
    ) => {
        if (submittedPayload?.whatsapp_template_flag_interactive_message) {
            setTemplateStatus(WHATSAPP_TEMPLATE_STATUS.APPROVED);
            return;
        }
        const metaStatus = responseData?.whatsapp_template_metadata?.meta_whatsapp_template_status_name;
        setTemplateStatus(metaStatus ?? WHATSAPP_TEMPLATE_STATUS.PENDING);
    };

    // Header Functions
    const onChangeOfInteractiveMessageSwitch = async (inputValue: boolean) => {
        if (inputValue) {
            
            const isHeaderTypeVideoOrDocument = ["video", "document"].includes(createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_type_name?.toLowerCase() || "");
            const header_storage_id = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_data_google_storage_id;
            
            if (isHeaderTypeVideoOrDocument && header_storage_id !== 0) {
                // Need to Delete File, when header type is video or document and header file is uploaded. Cause, interactive message don't support video or document in, header.
                removeUploadedFile(header_storage_id, false);
                setFiles([]);
            }

            if (!interactiveTypeList) {
                await getInteractiveTypeList();
            }

            const defaultListType = useTemplateLibraryStore.getState().interactiveTypeList?.find((interactiveType) =>
                isInteractiveTypeNameList(formatString(interactiveType?.interactive_type_name))
            );

            const defaultInteractiveScratch = createInteractiveTemplateFromScratch(templateLibraryCategoryList ?? [], whatsappTemplateButtonGenericData ?? [], whatsappTemplateTypes ?? [], defaultListType ? formatString(defaultListType?.interactive_type_name) : null);

            setCreateTemplatePayload({
                ...createTemplatePayload,
                whatsapp_template_flag_interactive_message: inputValue,
                interactive_type_id: defaultListType?.interactive_type_id ?? null,
                interactive_type_name: defaultListType?.interactive_type_name ?? null,
                interactive_list_button_text: defaultListType ? defaultButtonTextForListType : null,
                whatsapp_template_type_id: getTemplateTypeIdByName(whatsappTemplateTypes ?? [], TEMPLATE_TYPES['BASIC']),
                whatsapp_template_data: {
                    ...createTemplatePayload?.whatsapp_template_data,
                    ...defaultInteractiveScratch?.whatsapp_template_data,
                    whatsapp_template_category_id: 0,
                },
            } as createWhatsappTemplatePayloadForTemplateLibrary);
        } else {
            setCreateTemplatePayload({
                ...createTemplatePayload,
                whatsapp_template_flag_interactive_message: inputValue,
                interactive_type_id: null,
                interactive_list_button_text: null,
                whatsapp_template_data: {
                    ...createTemplatePayload?.whatsapp_template_data,
                    whatsapp_template_category_id: getTemplateCategoryId(TEMPLATE_CATEGORY?.UTILITY, templateLibraryCategoryList ?? []),
                    whatsapp_template_button: [],
                }
            });
        }
    }

    const onChangeOfInteractiveType = async (value: interactiveType | null) => {
        const interactiveTypeName = value ? formatString(value?.interactive_type_name) : null;
        const scratchPayload = createInteractiveTemplateFromScratch(
            templateLibraryCategoryList ?? [],
            whatsappTemplateButtonGenericData ?? [],
            whatsappTemplateTypes ?? [],
            interactiveTypeName
        ) as createWhatsappTemplatePayloadForTemplateLibrary;
        const interactiveValidations = getValidationsFromInteractiveType(value?.interactive_type_id, interactiveTypeList ?? []);

        const currentHeaderType = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_type_name?.toLowerCase() ?? "none";
        const allowedHeaderTypes = (interactiveValidations?.allowed_header_type ?? []).map((headerType) => headerType?.toLowerCase());
        const isCurrentHeaderSupported = value ? allowedHeaderTypes.includes(currentHeaderType) : true;
        const shouldClearFooter = value ? Number(interactiveValidations?.footer_text_character_limit ?? 0) === 0 : false;
        const shouldClearHeaderMediaFiles = value ? !isCurrentHeaderSupported : false;

        if (shouldClearHeaderMediaFiles) {
            const headerStorageId = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_data_google_storage_id ?? 0;
            if (headerStorageId) {
                removeUploadedFile(headerStorageId, false);
            }
            setFiles([]);
        }

        setCreateTemplatePayload({
            ...createTemplatePayload,
            interactive_type_id: value ? value?.interactive_type_id : null,
            interactive_type_name: value ? value?.interactive_type_name : null,
            interactive_list_button_text: (value && isInteractiveTypeNameList(interactiveTypeName))
                ? (createTemplatePayload?.interactive_list_button_text || defaultButtonTextForListType)
                : null,
            whatsapp_template_data: {
                ...createTemplatePayload?.whatsapp_template_data,
                ...(value
                    ? {
                        whatsapp_template_header: isCurrentHeaderSupported
                            ? createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header
                            : (scratchPayload?.whatsapp_template_data?.whatsapp_template_header ?? createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header),
                        whatsapp_template_body:
                            scratchPayload?.whatsapp_template_data?.whatsapp_template_body
                            ?? createTemplatePayload?.whatsapp_template_data?.whatsapp_template_body,
                        whatsapp_template_footer: shouldClearFooter
                            ? (scratchPayload?.whatsapp_template_data?.whatsapp_template_footer ?? createTemplatePayload?.whatsapp_template_data?.whatsapp_template_footer)
                            : createTemplatePayload?.whatsapp_template_data?.whatsapp_template_footer,
                        whatsapp_template_button: 
                            scratchPayload?.whatsapp_template_data?.whatsapp_template_button ?? [],
                    }
                    : {}),
            },
        } as createWhatsappTemplatePayloadForTemplateLibrary);

        if (value && isInteractiveTypeMessageFlow(value?.interactive_type_id, interactiveTypeList ?? []) && !publishedFlowList) {
            await getFlowListApi();
        }
    }

    const handleInteractiveTypeChange = (interactiveTypeId: number) => {
        const id = Number(interactiveTypeId);
        const selected = interactiveTypeList?.find((type: interactiveType) => type?.interactive_type_id === id) ?? null;
        onChangeOfInteractiveType(selected);
    }

    const handleLanguageChange = (languageId: number) => {
        const id = Number(languageId);
        if (!Number.isNaN(id)) {
            setCreateTemplatePayload({ ...createTemplatePayload, whatsapp_template_data: { ...createTemplatePayload?.whatsapp_template_data, whatsapp_language_id: id } } as createWhatsappTemplatePayloadForTemplateLibrary);
        }
    }

    const handleCategoryChange = (categoryId: number) => {
        const id = Number(categoryId);
        const authCategoryId = getTemplateCategoryId(TEMPLATE_CATEGORY?.AUTHENTICATION, templateLibraryCategoryList ?? []);
        const isCurrentAuth = isTemplateCategoryAuthentication(
            templateLibraryCategoryList,
            createTemplatePayload?.whatsapp_template_data?.whatsapp_template_category_id
        );

        if (!isCurrentAuth && !previousPayloadRef.current) {
            previousPayloadRef.current = createTemplatePayload;
        }

        const getBasePayload = () => (
            previousPayloadRef.current
            ?? createBasicTemplateFromScratch(templateLibraryCategoryList ?? [], whatsappTemplateButtonGenericData ?? []) as createWhatsappTemplatePayloadForTemplateLibrary
        );

        const buildPayloadWithCategory = (base: createWhatsappTemplatePayloadForTemplateLibrary, categoryId: number) => ({
            ...base,
            whatsapp_template_data: {
                ...base.whatsapp_template_data,
                whatsapp_template_category_id: categoryId,
            },
        });

        switch (id) {
            case authCategoryId: {
                if (!isCurrentAuth) {
                    previousPayloadRef.current = createTemplatePayload;
                }

                const authScratch = createAuthenticationTemplateFromScratch(
                    true,
                    templateLibraryCategoryList ?? [],
                    whatsappTemplateButtonGenericData ?? []
                ) as createWhatsappTemplatePayloadForTemplateLibrary;

                setCreateTemplatePayload({
                    ...createTemplatePayload,
                    flag_named_parameter: false,
                    whatsapp_template_data: {
                        ...createTemplatePayload?.whatsapp_template_data,
                        whatsapp_template_category_id: id,
                        whatsapp_template_body: authScratch?.whatsapp_template_data?.whatsapp_template_body,
                        whatsapp_template_footer: authScratch?.whatsapp_template_data?.whatsapp_template_footer,
                        whatsapp_template_button: authScratch?.whatsapp_template_data?.whatsapp_template_button ?? [],
                        whatsapp_template_code_expiration_minutes: authScratch?.whatsapp_template_data?.whatsapp_template_code_expiration_minutes ?? 10,
                        whatsapp_template_security_recommendation: authScratch?.whatsapp_template_data?.whatsapp_template_security_recommendation ?? false,
                    },
                } as createWhatsappTemplatePayloadForTemplateLibrary);
                break;
            }

            case getTemplateCategoryId(TEMPLATE_CATEGORY?.MARKETING, templateLibraryCategoryList ?? []):
            case getTemplateCategoryId(TEMPLATE_CATEGORY?.UTILITY, templateLibraryCategoryList ?? []): {
                const base = isCurrentAuth ? getBasePayload() : createTemplatePayload;
                setCreateTemplatePayload(buildPayloadWithCategory(base, id) as createWhatsappTemplatePayloadForTemplateLibrary);
                break;
            }

            default: {
                setCreateTemplatePayload(getBasePayload());
                previousPayloadRef.current = null;
                break;
            }
        }
    };

    const handleTemplateTypeChange = (typeId: number) => {

        const templateType = whatsappTemplateTypes?.find((type: getWhatsappTemplateTypeResponse) => type?.whatsapp_template_type_id === typeId);
        
        if(templateType){
            const templateTypeName = templateType?.name ?? '';

            let updatedPayload = {
                ...createTemplatePayload,
                whatsapp_template_type_id: typeId,
            }

            switch (templateTypeName?.toLowerCase()) {
                case TEMPLATE_TYPES['CATALOG']?.toLowerCase():
                    updatedPayload = createCatalogTemplateFromScratch(templateLibraryCategoryList ?? [], whatsappTemplateButtonGenericData ?? [], whatsappTemplateTypes ?? []) as createWhatsappTemplatePayloadForTemplateLibrary;
                    break;
                case TEMPLATE_TYPES['BASIC']?.toLowerCase():
                    updatedPayload = createBasicTemplateFromScratch(templateLibraryCategoryList ?? [], whatsappTemplateButtonGenericData ?? []) as createWhatsappTemplatePayloadForTemplateLibrary;
                    break;
                case TEMPLATE_TYPES['CAROUSEL']?.toLowerCase():
                    updatedPayload = createCarouselTemplateFromScratch(templateLibraryCategoryList ?? [], whatsappTemplateButtonGenericData ?? [], whatsappTemplateTypes ?? [], whatsappTemplateHeaderTypes ?? []) as unknown as createWhatsappTemplatePayloadForTemplateLibrary;
                    break;
                case TEMPLATE_TYPES['CALL_PERMISSION_REQUEST']?.toLowerCase():
                    updatedPayload = createCallPermissionRequestTemplateFromScratch(templateLibraryCategoryList ?? [], whatsappTemplateButtonGenericData ?? [], whatsappTemplateTypes ?? []) as createWhatsappTemplatePayloadForTemplateLibrary;
                    break;
                default:
                    updatedPayload = {
                        ...updatedPayload,
                        whatsapp_template_data: {
                            ...updatedPayload?.whatsapp_template_data,
                            whatsapp_template_button: [],
                        }
                    }
                    break;
            }

            setCarouselFiles([]);
            if (templateTypeName?.toLowerCase() === TEMPLATE_TYPES['CAROUSEL']?.toLowerCase()) {
                setCarouselInvalidId([
                    { index: 0, inValidIds: [] },
                    { index: 1, inValidIds: [] },
                ]);
            } else {
                setCarouselInvalidId([]);
            }

            setCreateTemplatePayload(updatedPayload);
        }
    }

    const flagCategoryEditable = (createTemplatePayload: createWhatsappTemplatePayloadForTemplateLibrary, category_id: number) => {
        if (isInteractiveTemplate(createTemplatePayload)) {
            return false;
        } else {
            // if (category_id === 3) {
            //     return false;
            // } else {
                if (isCarouselTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id) || isCatalogTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id)) {
                    return false;
                }
                else if (createTemplatePayload?.whatsapp_template_id) {
                    return false;
                } else {
                    return true;
                }
            // }
        }
    }


    // Disable Submit Template Functions
    const checkIfFlowButtonIsExist = () => {
        const isFlowButtonExist = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button?.find((button) => isFlowButton(button?.whatsapp_template_button_type_id || 0, whatsappTemplateButtonGenericData))
        if (isFlowButtonExist) {
            return true;
        }
        return false;
    }

    const checkIfHeaderDataIsFillOrNot = () => {
        const headerType = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_type_name;
        const headerVariableData =
            createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data ?? [];
        const getLocationSampleValue = (variableKey: string) =>
            (headerVariableData.find(
                (variable: any) => variable?.whatsapp_template_dynamic_variable_key?.toLowerCase() === variableKey.toLowerCase()
            )?.whatsapp_template_dynamic_variable_sample_value ?? '').trim();

        if (createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header &&
            (headerType?.toLowerCase() === "none"
                ||
                (headerType?.toLowerCase() === "text" &&
                    createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data[0]?.whatsapp_template_header_data_value?.trim().length > 0 &&
                    createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data[0]?.whatsapp_template_header_variable_data?.filter((variable) => variable?.whatsapp_template_dynamic_variable_sample_value?.trim() === "").length === 0
                )
                ||
                ((headerType?.toLowerCase() === "image" || headerType?.toLowerCase() === "video" || headerType?.toLowerCase() === "document") && files.length > 0)
                ||
                (headerType?.toLowerCase() === "location" &&
                    LOCATION_HEADER_FIELDS
                        .filter((field) => field.required)
                        .every((field) => getLocationSampleValue(field.key).length > 0)
                    && isValidLatitudeValue(getLocationSampleValue('{{latitude}}'))
                    && isValidLongitudeValue(getLocationSampleValue('{{longitude}}'))
                )
            )) {
            return true;
        }
        if(isAuthenticationTemplate) {
            return true;
        }
        return false;
    }


    // Check Disable Submit Template
    const handleSubmitTemplateDisabled = () => {
        const templateData = createTemplatePayload?.whatsapp_template_data;
        
        if (!templateData) return true;

        // Category
        if(!isInteractiveTemplate(createTemplatePayload) && !templateData?.whatsapp_template_category_id) {
            return true;
        }
        
        // Display Name
        if ((templateData?.whatsapp_template_display_name ?? '').trim().length === 0) {
            return true;
        }

        // Language
        if (!isInteractiveTemplate(createTemplatePayload) && templateData?.whatsapp_language_id === 0) {
            return true;
        }

        // Check if the button text is unique
        if (hasDuplicateButtonText(templateData?.whatsapp_template_button ?? [])) {
            return true;
        }
        
        const templateBody = templateData?.whatsapp_template_body;
        
        // Condition to check for disable when template type is catalog
        if (isTemplateTypeCatalog &&
            (
                (templateBody?.whatsapp_template_body_value ?? '').trim().length === 0 ||
                (templateBody?.whatsapp_template_body_variable_data ?? []).filter((data: any) => (data?.whatsapp_template_dynamic_variable_sample_value ?? "").trim() === "").length !== 0 ||
                checkFlagError("body", createTemplatePayload) ||
                !checkTypeOfVariableValidation('body') ||
                doesCreateTemplateBodyHaveInvalidFormatting(createTemplatePayload, templateLibraryCategoryList ?? []) ||
                inValidId.length > 0
            )
        ) {
            return true;
        }

        //Condition to check for disable when template type is basic or call permission request
        if ((isTemplateTypeCallPermissionRequest || isBasicTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id)) &&
            (
                (templateBody?.whatsapp_template_body_value ?? '').trim().length === 0 ||
                // templateBody?.whatsapp_template_body_description.trim().length === 0 ||
                (templateBody?.whatsapp_template_body_variable_data ?? []).filter((data: any) => (data?.whatsapp_template_dynamic_variable_sample_value ?? "").trim() === "").length !== 0 ||
                checkFlagError("both", createTemplatePayload) ||
                !checkTypeOfVariableValidation('both') ||
                !checkIfHeaderDataIsFillOrNot() ||
                doesBodyTextStartOrEndWithVariable(createTemplatePayload) ||
                doesCreateTemplateBodyHaveInvalidFormatting(createTemplatePayload, templateLibraryCategoryList ?? []) ||
                inValidId.length > 0
            )
        ) {
            return true
        }

        // Minimum button and Interactive Type condition for interactive message template.
        if (isInteractiveTemplate(createTemplatePayload)) {
            if (!createTemplatePayload?.interactive_type_id ||
                (templateData?.whatsapp_template_button?.length ?? 0) < (getValidationsFromInteractiveType(createTemplatePayload?.interactive_type_id, interactiveTypeList)?.minimum_button_count ?? 0)) {
                return true;
            }
            if (isInteractiveTypeMessageList(createTemplatePayload?.interactive_type_id, interactiveTypeList)) {
                if (createTemplatePayload?.interactive_list_button_text?.trim()?.length === 0) {
                    return true;
                }
            }
        }

        //Condition to check for disable when template type is basic
        if ((whatsappTemplateTypes?.find((types) => types.whatsapp_template_type_id === createTemplatePayload?.whatsapp_template_type_id)?.name?.toLowerCase() === TEMPLATE_TYPES['BASIC']?.toLowerCase())) {
            for (const button of (templateData?.whatsapp_template_button ?? [])) {

                for (const buttonData of (button?.whatsapp_template_button_data ?? [])) {
                    for (const fieldData of (buttonData?.whatsapp_template_button_sub_type_field_data ?? [])) {
                        if (fieldData?.field_static_value_flag === true) {
                            continue;
                            // return false;
                        }
                        if ((fieldData?.field_name ?? '').toLowerCase() === "website url" && fieldData?.whatsapp_template_button_field_data_variable && fieldData?.whatsapp_template_button_field_data_variable.length > 0) {
                            if ((fieldData.whatsapp_template_button_field_data_variable?.[0]?.whatsapp_template_dynamic_variable_sample_value ?? '').trim().length === 0) {
                                return true;
                            }
                        }
                        if ((fieldData?.field_name ?? '').toLowerCase() === "website url" && isInvalidUrl((fieldData?.whatsapp_template_button_sub_type_field_value as string) ?? '')) {
                            return true;
                        }
                        if ((fieldData?.field_type ?? '').toLowerCase() === "textfield" && (!fieldData?.whatsapp_template_button_sub_type_field_value || (typeof fieldData?.whatsapp_template_button_sub_type_field_value === "string" && (fieldData?.whatsapp_template_button_sub_type_field_value ?? '').trim() === ''))
                        ) {
                            if ((fieldData?.field_name ?? '').toLowerCase() !== "button description") {
                                return true;
                            }
                        }
                        if ((fieldData?.field_name ?? '').toLowerCase() === "payload" && (typeof fieldData?.whatsapp_template_button_sub_type_field_value === "object" && (fieldData?.whatsapp_template_button_sub_type_field_value ?? []).filter((values: any) => (values?.payload_key ?? '').trim() === "" || (values?.payload_key_value ?? '').trim() === "")?.length > 0)
                        ) {
                            return true;
                        }
                        if ((fieldData?.field_type ?? '').toLowerCase() === "autocomplete") {
                            if (isFlowButton(button?.whatsapp_template_button_type_id || 0, whatsappTemplateButtonGenericData)) {
                                if (!fieldData?.whatsapp_template_button_sub_type_field_value) {
                                    return true;
                                }
                            } else {
                                if (fieldData?.whatsapp_template_button_sub_type_field_option_id == null || Number(fieldData?.whatsapp_template_button_sub_type_field_option_id) === 0) {
                                    return true;
                                }
                            }
                        }
                        // if (fieldData.field_type.toLowerCase() == "autocomplete" && (fieldData.whatsapp_template_button_sub_type_field_option_id == null || Number(fieldData.whatsapp_template_button_sub_type_field_option_id) === 0)
                        // ) {
                        //     return true;
                        // }
                    }
                }
            }
        }

        const hasConsecutiveNewlinesInCarouselMessageBody = hasConsecutiveNewlinesInCarouselBody(
            templateData?.whatsapp_template_carousel?.whatsapp_template_carousel_header ?? ''
        );

        const hasConsecutiveNewlinesInAnyCarouselCardBody = (templateData?.whatsapp_template_carousel?.whatsapp_template_carousel_card ?? []).some(
            (card: any) => hasConsecutiveNewlinesInCarouselBody(card?.whatsapp_template_body?.whatsapp_template_body_value ?? '')
        );

        //Condition to check for disable when template type is carousel
        if (isCarouselTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id) &&
            (createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_header?.trim()?.length === 0 ||
                checkFlagErrorCarousel("header") ||
                doesCarouselMessageBodyTextStartOrEndWithVariable(createTemplatePayload) ||
                checkBodyValueVariableCard() ||
                checkButtonVariableCard() ||
                !checkHeaderCard() ||
                // !checkBodyDescriptionCards() ||  Not Required Body Description
                !checkBodyValueCards() ||
                !checkBodyVariableCard() ||
                !checkButtonLengthCard() ||
                !checkIfHeaderDataIsFillOrNotCarousel(carouselFiles) ||
                carouselInvalidId?.find((ids: any) => ids.inValidIds?.length > 0)
                || existingPayloadKey?.length > 0
                || hasConsecutiveNewlinesInCarouselMessageBody
                || hasConsecutiveNewlinesInAnyCarouselCardBody
                || (templateData?.whatsapp_template_carousel?.whatsapp_template_carousel_card ?? []).some((card: any) => hasDuplicateButtonText(card?.whatsapp_template_button ?? []))
            )
        ) {
            return true
        }

        if (invalidPayloadObjectId?.length > 0) return true; // If Flow Payload Object is not valid json


        if(createTemplatePayload?.whatsapp_template_id){
            if(JSON.stringify(createTemplatePayload) === JSON.stringify(existingTemplateData)) {
                return true;
            }
            if(areBodyVariablesModified(createTemplatePayload, existingTemplateData) || areHeaderVariablesModified(createTemplatePayload, existingTemplateData)){
                return true;
            }
        }


        //if every condition fails return false
        return false;
    }

    // Handle Submit Template
    const handleSubmitTemplate = async () => {
        if(!isValidWabaId(id, integrationListNewStructure)) {
            setShowConnectWabaModal(true);
            return;
        }

        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))

        try {
            let payload: any = { ...createTemplatePayload };
            const headerType = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_type_name;
            if (headerType?.toLowerCase() === "none") {
                if (payload?.whatsapp_template_data?.whatsapp_template_header && payload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data && payload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data?.length > 0) {
                    payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_data_id = null;
                }
                else {
                    payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data = [{
                        whatsapp_template_header_data_value: "",
                        whatsapp_template_header_data_id: 0,
                        whatsapp_template_header_data_google_storage_id: 0,
                        whatsapp_template_header_variable_data: []
                    }];
                }
                payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_id = null;
                payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_type_id = null;
                setExistingHeaderTemplateVariableData(null);
            }


            let response;
            //this is to add static - variable data
            if (headerType?.toLowerCase() === "image" || headerType?.toLowerCase() === "video" || headerType?.toLowerCase() === "document") {

                let dynamic_variable_id = null, unique_id = 0, history_id = null, added_by_change_log_id = 0, variable_flag_deleted = false;
                if (existingHeaderTemplateVariableData && existingHeaderTemplateVariableData.length > 0 && existingHeaderTemplateVariableData[0]) {
                    dynamic_variable_id = "whatsapp_template_dynamic_variable_id" in existingHeaderTemplateVariableData[0] ? existingHeaderTemplateVariableData[0].whatsapp_template_dynamic_variable_id : 0;
                    unique_id = "whatsapp_template_dynamic_variable_unique_id" in existingHeaderTemplateVariableData[0] ? existingHeaderTemplateVariableData[0].whatsapp_template_dynamic_variable_unique_id : 0;
                    history_id = "history_id" in existingHeaderTemplateVariableData[0] ? existingHeaderTemplateVariableData[0].history_id : null;
                }

                payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data = [{
                    whatsapp_template_dynamic_variable_id: createTemplatePayload?.whatsapp_template_id ? dynamic_variable_id : 0,
                    // whatsapp_template_dynamic_variable_type_id: whatsappTemplateHeaderTypes?.find((hType: any) => hType.whatsapp_template_header_type_name === headerType)?.whatsapp_template_header_type_id,
                    whatsapp_template_dynamic_variable_type_id: whatsappTemplateDynamicVarTypes?.find((varType) => varType?.whatsapp_template_dynamic_variable_type_name?.toLowerCase() == 'header')?.whatsapp_template_dynamic_variable_type_id,
                    whatsapp_template_dynamic_variable_unique_id: createTemplatePayload?.whatsapp_template_id ? unique_id : 0,
                    whatsapp_template_dynamic_variable_key: payload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data?.[0]?.whatsapp_template_dynamic_variable_key ?? `{{Header${headerType}}}`,
                    whatsapp_template_dynamic_variable_sample_value: payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_data_value || payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data?.[0]?.whatsapp_template_dynamic_variable_sample_value,
                    history_id: createTemplatePayload?.whatsapp_template_id ? history_id : null,
                    added_by_change_log_id: createTemplatePayload?.whatsapp_template_id ? added_by_change_log_id : 0,
                    whatsapp_template_dynamic_variable_flag_deleted: createTemplatePayload?.whatsapp_template_id ? variable_flag_deleted : false,
                    whatsapp_template_id: createTemplatePayload.whatsapp_template_id ? payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data?.[0]?.whatsapp_template_id : 0,
                    flag_header: createTemplatePayload?.whatsapp_template_id ? payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data?.[0]?.flag_header : null,
                    flag_button: createTemplatePayload?.whatsapp_template_id ? payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data?.[0]?.flag_button : null,
                    whatsapp_template_dynamic_variable_type_name: "Header"
                }]
            } else if (headerType?.toLowerCase() === "text" && (payload.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data?.length ?? 0) > 0) {
                let dynamic_variable_id = null;
                if (existingHeaderTemplateVariableData && existingHeaderTemplateVariableData.length > 0 && existingHeaderTemplateVariableData[0]) {
                    dynamic_variable_id = "whatsapp_template_dynamic_variable_id" in existingHeaderTemplateVariableData[0] ? existingHeaderTemplateVariableData[0].whatsapp_template_dynamic_variable_id : null;
                }

                payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data[0].whatsapp_template_dynamic_variable_id = dynamic_variable_id;
            }
            if (createTemplatePayload?.whatsapp_template_data.whatsapp_template_footer.whatsapp_template_footer_value === "") {
                payload.whatsapp_template_data.whatsapp_template_footer.whatsapp_template_footer_id = 0;
            }

            if (checkIfFlowButtonIsExist()) {
                payload.whatsapp_template_flag_flow = true;
            } else {
                payload.whatsapp_template_flag_flow = false;
            }

            if(Number(payload?.whatsapp_template_data?.whatsapp_template_category_id) === getTemplateCategoryId(TEMPLATE_CATEGORY?.AUTHENTICATION, templateLibraryCategoryList ?? [])) {
                delete payload?.whatsapp_template_data?.whatsapp_template_header;
            }

            if(payload?.whatsapp_template_data?.whatsapp_template_display_name?.trim()?.length > 0) {
                payload.whatsapp_template_data.whatsapp_template_name = "";
            }

            if (createTemplatePayload?.whatsapp_template_id) {
                response = await agent.updateWhatsappTemplate.put(payload);
            } else {
                payload.meta_integration_whatsapp_id = Number(id);
                response = await agent.createWhatsappTemplate.post(payload);
            }

            if (response.status) {
                showSuccess(createTemplatePayload?.whatsapp_template_id ? "Template Updated Successfully!" : "Template Created Successfully!")
                const newTemplateId = response?.data?.[0]?.whatsapp_template_id ?? payload.whatsapp_template_id;
                const submittedPayload = { ...payload, whatsapp_template_id: newTemplateId };
                
                setCreateTemplatePayload(submittedPayload);
                setExistingTemplateData(submittedPayload);
                setExistingPayloadData(submittedPayload);
                initialPayloadRef.current = structuredClone(submittedPayload);
                setHasUnsavedChanges(false);
                syncTemplateStatusAfterSubmit(submittedPayload, response?.data?.[0]);

                if (draft_id) {
                    deleteDraftTemplate(draft_id).catch(() => undefined);
                }

                if (newTemplateId && !template_id) {
                    navigate(`/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate?id=${id}&template_id=${newTemplateId}`, { replace: true });
                }

                openPostSubmitPopup(!!createTemplatePayload?.whatsapp_template_id);
            } else {
                handleError(response);
            }
        } finally {
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
        }
    }

    const handleSubmitCarouselTemplate = async () => {
        
        if(!isValidWabaId(id, integrationListNewStructure)) {
            setShowConnectWabaModal(true);
            return;
        }

        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))

        try {
            let payload = { ...createTemplatePayload };

            payload.whatsapp_template_data.whatsapp_template_header = {} as createWhatsappTemplateHeader;
            payload.whatsapp_template_data.whatsapp_template_body = {} as createWhatsappTemplateBody;
            payload.whatsapp_template_data.whatsapp_template_button = [];
            payload.whatsapp_template_data.whatsapp_template_footer = {} as createWhatsappTemplateFooter;

            const headerType = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.[0]?.whatsapp_template_header?.whatsapp_template_header_type_name;
            let response;

            if (headerType?.toLowerCase() === "image" || headerType?.toLowerCase() === "video") {
                payload.whatsapp_template_data.whatsapp_template_carousel.whatsapp_template_carousel_card = payload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.map((cards) => {
                    return {
                        ...cards,
                        whatsapp_template_header: {
                            ...cards.whatsapp_template_header,
                            whatsapp_template_header_data: cards.whatsapp_template_header?.whatsapp_template_header_data?.map((headerData) => {
                                return {
                                    ...headerData,
                                    whatsapp_template_header_variable_data: [{
                                        // whatsapp_template_dynamic_variable_id: createTemplatePayload.whatsapp_template_id ? dynamic_variable_id : 0,
                                        whatsapp_template_dynamic_variable_id: 0,
                                        whatsapp_template_dynamic_variable_key: `{{Header${headerType}}}`,
                                        whatsapp_template_dynamic_variable_sample_value: headerData?.whatsapp_template_header_data_value
                                    }]
                                }
                            })
                        },
                    }
                })
            }

            if (createTemplatePayload.whatsapp_template_id) {
                response = await agent.updateWhatsappTemplate.put(payload as createWhatsappTemplatePayload)
            }
            else {
                payload.meta_integration_whatsapp_id = Number(id);
                response = await agent.createWhatsappTemplate.post(payload)
            }
            if (response.status) {
                showSuccess(createTemplatePayload.whatsapp_template_id ? "Template Updated Successfully!" : "Template Created Successfully!")
                const newTemplateId = response?.data?.[0]?.whatsapp_template_id ?? payload.whatsapp_template_id;
                const submittedPayload = { ...payload, whatsapp_template_id: newTemplateId };
                
                setCreateTemplatePayload(submittedPayload);
                setExistingTemplateData(submittedPayload);
                setExistingPayloadData(submittedPayload);
                initialPayloadRef.current = structuredClone(submittedPayload);
                setHasUnsavedChanges(false);
                syncTemplateStatusAfterSubmit(submittedPayload, response?.data?.[0]);

                if (draft_id) {
                    deleteDraftTemplate(draft_id).catch(() => undefined);
                }

                if (newTemplateId && !template_id) {
                    navigate(`/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate?id=${id}&template_id=${newTemplateId}`, { replace: true });
                }

                openPostSubmitPopup(!!createTemplatePayload?.whatsapp_template_id);
            }
            else {
                handleError(response);
            }
        } finally {
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
        }
    }

    // Handle Save Draft
    const handleSaveDraft = async () => {
        setIsSavingDraft(true);
        
        const templateName = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_display_name?.trim() ?? "";
        
        const draftPayload = {
            ...createTemplatePayload,
            whatsapp_template_data: {
                ...createTemplatePayload?.whatsapp_template_data,
                whatsapp_template_display_name: templateName || "Untitled Template",
            },
            whatsapp_template_flag_flow: checkIfFlowButtonIsExist(),
        };
        
        const payloadToSave = isCarouselTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id)
            ? normalizeTemplatePayloadForDraft(draftPayload, whatsappTemplateTypes ?? [])
            : draftPayload;
        
        const payload = {
            whatsapp_template_category_id: createTemplatePayload?.whatsapp_template_data?.whatsapp_template_category_id,
            json_data: JSON.stringify(payloadToSave),
            ...(draft_id && { whatsapp_template_draft_id: draft_id }),
        }

        try {
            const response = await createDraftTemplate(payload);

            if (response.status) {
                if (initialPayloadRef) {
                    initialPayloadRef.current = payloadToSave;
                }
                setCreateTemplatePayload(payloadToSave as createWhatsappTemplatePayloadForTemplateLibrary);
                setTemplateStatus("Draft");
                setHasUnsavedChanges(false);

                const newDraftId = response?.data?.[0]?.whatsapp_template_draft_id;
                if (!draft_id && newDraftId) {
                    navigate(`/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate?id=${id}&draft_id=${newDraftId}`, { replace: true });
                }

                showSuccess(draft_id ? "Draft Updated Successfully!" : "Draft Saved Successfully!")
            } else {
                handleError(response);
            }
        } finally {
            setIsSavingDraft(false);
        }
    }

    // Actions Button Functions
    const isSubmitDisabled = handleSubmitTemplateDisabled();
    
    const createButtonLabel = isTemplateCreated(createTemplatePayload)
        ? (isScreenBelow1250 ? "Update" : "Update Template")
        : (isScreenBelow1250 ? "Create" : "Create Template");
    
    const handleCreateClick = isCarouselTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id)
        ? handleSubmitCarouselTemplate
        : handleSubmitTemplate;

    const headerFormToggle = (
        <TouchTooltip  title={formOpen ? "Close Form" : "Open Form"}>
            <button
                type="button"
                className={`${globalStyles.clickable} ${styles.modifyTemplate__settingsButton}`}
                onClick={() => setFormOpen(!formOpen)}
            >
                {formOpen ? <VisibilityOffIcon /> : <TuneIcon />}
            </button>
        </TouchTooltip>
    );

    const headerMenuTrigger = (
        <MoreVertIcon
            className={`${globalStyles.clickable} ${styles.modifyTemplate__headerMenuIcon}`}
            onClick={handleMenuOpen}
        />
    );

    const headerCreateButton = isScreenBelow1250 ? (
        <button
            type="button"
            className={`${globalStyles.clickable} ${styles.modifyTemplate__headerCreateBtn}`}
            onClick={handleCreateClick}
            disabled={isSubmitDisabled}
        >
            {createButtonLabel}
        </button>
    ) : (
        <GlobalButton
            buttonText={createButtonLabel}
            className="primaryButtonStyle"
            onClick={handleCreateClick}
            disabled={isSubmitDisabled}
            sx={{ opacity: isSubmitDisabled ? 0.5 : 1 }}
        />
    );


    // UseEffects
    useEffect(() => {
        if (!initialPayloadRef?.current) return;

        const hasChanges = !isEqual(createTemplatePayload, initialPayloadRef.current);
        if (hasUnsavedChanges !== hasChanges) {
            setHasUnsavedChanges(hasChanges);
        }
    }, [createTemplatePayload, hasUnsavedChanges, initialPayloadRef, setHasUnsavedChanges]);

    useLayoutEffect(() => {
        setCreateTemplatePayload({
            ...createTemplatePayload,
            whatsapp_template_type_id: createTemplatePayload?.whatsapp_template_type_id ? createTemplatePayload?.whatsapp_template_type_id : 1,
            whatsapp_template_data: {
                ...createTemplatePayload?.whatsapp_template_data,
                whatsapp_template_display_name: createTemplatePayload?.whatsapp_template_data?.whatsapp_template_display_name?.trim() ? createTemplatePayload?.whatsapp_template_data?.whatsapp_template_display_name?.trim() : "Untitled Template",
                whatsapp_language_id: (createTemplatePayload?.whatsapp_template_data?.whatsapp_language_id && createTemplatePayload?.whatsapp_template_data?.whatsapp_language_id !== 0) ? createTemplatePayload?.whatsapp_template_data?.whatsapp_language_id : 15,
                whatsapp_template_category_id: createTemplatePayload?.whatsapp_template_data?.whatsapp_template_category_id ?? getTemplateCategoryId(TEMPLATE_CATEGORY?.MARKETING, templateLibraryCategoryList ?? []),
            },
        } as createWhatsappTemplatePayloadForTemplateLibrary);
    }, []);

    return (
        <>
            <Grid container className={styles.modifyTemplate}>
                <Grid item xs={12}
                    className={`${styles.modifyTemplate__headerWrapper} ${shouldShowTemplateStatus && templateStatus ? styles.modifyTemplate__headerWrapperWithStatus : styles.modifyTemplate__headerWrapperNoStatus}`}
                >

                    {/* Left: back beside name; status under name only */}
                    <Grid item className={styles.modifyTemplate__headerRowLeft}>
                        <ArrowBack
                            onClick={handleBackButtonClick}
                            className={`${globalStyles.clickable} ${globalStyles.primaryColor} ${styles.modifyTemplate__headerBack}`}
                        />

                        <div className={styles.modifyTemplate__templateNameStatusRow}>
                            <Grid item display="flex" alignItems="center" justifyContent="flex-start" gap={0.5} flexWrap="nowrap"
                                className={`${styles.modifyTemplate__templateNameWrapper} ${hasNoTemplateName() ? styles.modifyTemplate__templateNameWrapperError : ""} ${template_id ? styles.modifyTemplate__templateNameWrapperReadonly : ""} ${hoverEditTemplateName && !template_id ? styles.modifyTemplate__templateNameWrapperActive : ""}`}
                                onMouseEnter={() => {
                                    if (!template_id) setHoverEditTemplateName(true);
                                }}
                                onMouseLeave={() => {
                                    if (!isTemplateNameTruncated) setHoverEditTemplateName(false);
                                }}
                            >
                                {template_id ? (
                                    <TouchTooltip
                                        title={isTemplateNameTruncated ? templateName : ""}
                                        placement={isMobileScreen ? 'top-start' : 'bottom'}
                                    >
                                        <Typography
                                            ref={templateNameRef}
                                            className={`${hasNoTemplateName() ? styles.modifyTemplate__titleError : styles.modifyTemplate__title}`}
                                        >
                                            {hasNoTemplateName() 
                                                ? "Enter template name" 
                                                : (createTemplatePayload?.whatsapp_template_data?.whatsapp_template_display_name 
                                                    ?? createTemplatePayload?.whatsapp_template_data?.whatsapp_template_name 
                                                    ?? "Untitled Template"
                                                )
                                            }
                                        </Typography>
                                    </TouchTooltip>
                                ) : (
                                    <TouchTooltip 
                                        title={isTemplateNameTruncated ? templateName : ""}
                                        placement={isMobileScreen ? 'top-start' : 'bottom'}
                                        onClose={() => setHoverEditTemplateName(false)}
                                    >
                                        <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            fullWidth
                                            className={`${hasNoTemplateName() ? styles.modifyTemplate__templateNameInputError : styles.modifyTemplate__templateNameInput}`}
                                            placeholder='Enter template name'
                                            size="small"
                                            inputRef={templateNameRef}
                                            inputProps={{ dir: 'auto' }}
                                            onChange={(e) => {
                                                const inputValue = e.target.value;
                                            
                                                // Allow only English letters, numbers, underscores, and spaces
                                                if (!TEMPLATE_NAME_REGEX.test(inputValue)) {
                                                    return;
                                                }
                                            
                                                if (inputValue.length > TEMPLATE_NAME_MAX_LIMIT) {
                                                    showInfo(TEMPLATE_NAME_MAX_CHARS_MESSAGE);
                                                    return;
                                                }
                                            
                                                setCreateTemplatePayload({
                                                    ...createTemplatePayload,
                                                    whatsapp_template_data: {
                                                        ...createTemplatePayload.whatsapp_template_data,
                                                        whatsapp_template_display_name: inputValue,
                                                    },
                                                } as createWhatsappTemplatePayloadForTemplateLibrary);
                                            }}
                                            value={templateName}
                                            autoComplete='off'
                                        />
                                    </TouchTooltip>
                                )}
                            </Grid>

                            {shouldShowTemplateStatus && templateStatus && (
                                <span className={`${styles.modifyTemplate__templateStatus} ${getStatusChipStyle()}`}>
                                    {templateStatus}
                                </span>
                            )}
                        </div>
                    </Grid>

                    {/* Right */}
                    <Grid item display="flex" alignItems="center" justifyContent="center" gap={2} flexWrap="nowrap" flexShrink={0}
                        className={styles.modifyTemplate__headerRowRight}
                    >

                        <Grid item display="flex" alignItems="center" justifyContent="center" gap={1} flexWrap="nowrap" flexShrink={0} 
                            className={styles.modifyTemplate__headerFilters}
                        >

                            {/* Interactive Message Type */}
                            {isInteractiveTemplate(createTemplatePayload) && (
                                <Grid item display="flex" flexDirection="column" alignItems="flex-start" justifyContent="flex-start" flexWrap="nowrap" gap={0.5} className={styles.modifyTemplate__section}>
                                    
                                    <Typography component="span" className={styles.modifyTemplate__fieldLabel}>
                                        Interactive Message Type
                                    </Typography>

                                    <Select
                                        disabled={!!createTemplatePayload?.whatsapp_template_id}
                                        labelId="template-interactive-type-select-label"
                                        id="template-interactive-type-select"
                                        placeholder="Select interactive message type"
                                        displayEmpty
                                        size="small"
                                        value={(() => {
                                            const typeId = createTemplatePayload?.interactive_type_id;
                                            const isValidId = typeId != null && typeId !== 0 && String(typeId).trim() !== "";
                                            return isValidId ? typeId : "";
                                        })()}
                                        onChange={(e: any) => handleInteractiveTypeChange(e.target.value)}
                                        className={`${styles.modifyTemplate__select} ${styles.modifyTemplate__selectInteractiveType}`}
                                        renderValue={(value) => {
                                            const selected = interactiveTypeList?.find(
                                                (type: interactiveType) => Number(type?.interactive_type_id) === Number(value)
                                            );
                                            return selected ? formatString(selected?.interactive_type_name ?? "") : "Select interactive message type";
                                        }}
                                        MenuProps={{
                                            anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                            transformOrigin: { vertical: "top", horizontal: "left" },
                                            PaperProps: { className: styles.modifyTemplate__selectMenu, style: { maxHeight: 250, maxWidth: 200 } },
                                        }}
                                    >
                                        {interactiveTypeList?.map((option: interactiveType, ind: number) => (
                                            <MenuItem value={option?.interactive_type_id} key={ind}
                                                sx={{
                                                    fontSize: '13px',
                                                    whiteSpace: 'normal',
                                                    wordBreak: 'break-word',
                                                }}
                                            >
                                                {formatString(option?.interactive_type_name ?? "")}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                            )}

                            {!isInteractiveTemplate(createTemplatePayload) && (
                                <>
                                    {/* Category */}
                                    <Grid item display="flex" flexDirection="column" alignItems="flex-start" justifyContent="flex-start" flexWrap="nowrap" gap={0.5} 
                                        className={styles.modifyTemplate__section}
                                    >
                                        <Typography component="span" className={styles.modifyTemplate__fieldLabel}>
                                            Category
                                        </Typography>

                                        <Select
                                            disabled={isCategorySelectionDisabled}
                                            labelId="template-category-select-label"
                                            id="template-category-select"
                                            placeholder='Select category'
                                            displayEmpty
                                            size="small"
                                            value={(() => {
                                                const categoryId = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_category_id;
                                                const isValidId = categoryId != null && categoryId !== 0 && String(categoryId).trim() !== "";
                                                const idToShow = isValidId ? categoryId : 1;
                                                return idToShow !== 0 ? idToShow : "";
                                            })()}
                                            onChange={(e: any) => handleCategoryChange(e.target.value)}
                                            className={`${styles.modifyTemplate__select} ${styles.modifyTemplate__selectCategory}`}
                                            renderValue={(value) => {
                                                const selected = templateLibraryCategoryList?.find((category: any) => category?.whatsapp_template_category_id === value);
                                                return selected?.whatsapp_template_category_name ?? "Select category";
                                            }}
                                            MenuProps={{
                                                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                                transformOrigin: { vertical: "top", horizontal: "left" },
                                                PaperProps: { className: styles.modifyTemplate__selectMenu, style: { maxHeight: 250, maxWidth: 140, fontSize: '12px' } },
                                            }}
                                        >
                                            {templateLibraryCategoryList?.filter((option: any) =>
                                                !isTemplateTypeCallPermissionRequest || !isTemplateCategoryAuthentication(templateLibraryCategoryList, option?.whatsapp_template_category_id)
                                            ).map((option: any, ind: number) => (
                                                <MenuItem value={option.whatsapp_template_category_id} key={ind}
                                                    sx={{
                                                        fontSize: '13px',
                                                        whiteSpace: 'normal',
                                                        wordBreak: 'break-word',
                                                    }}
                                                    disabled={!flagCategoryEditable(createTemplatePayload, option?.whatsapp_template_category_id)}
                                                >
                                                    {option?.whatsapp_template_category_name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>

                                    {/* Language */}
                                    <Grid item display="flex" flexDirection="column" alignItems="flex-start" justifyContent="flex-start" flexWrap="nowrap" gap={0.5} 
                                        className={styles.modifyTemplate__section}
                                    >
                                        <Typography component="span" className={styles.modifyTemplate__fieldLabel}>
                                            Language
                                        </Typography>

                                        <Select
                                            disabled={!!createTemplatePayload?.whatsapp_template_id}
                                            labelId="template-language-select-label"
                                            id="template-language-select"
                                            placeholder='Select language'
                                            displayEmpty
                                            size="small"
                                            value={(() => {
                                                const languageId = createTemplatePayload?.whatsapp_template_data?.whatsapp_language_id;
                                                const isValidId = languageId != null && languageId !== 0 && String(languageId).trim() !== "";
                                                const idToShow = isValidId ? languageId : 15;
                                                return idToShow !== 0 ? idToShow : 0;
                                            })()}
                                            onChange={(e: any) => handleLanguageChange(e.target.value)}
                                            className={`${styles.modifyTemplate__select} ${styles.modifyTemplate__selectLanguage}`}
                                            renderValue={(value) => {
                                                const selected = whatsappTemplateLanguages?.find((language: any) => language?.whatsapp_language_id === value);
                                                return selected?.whatsapp_language_name ?? "Select language";
                                            }}
                                            MenuProps={{
                                                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                                transformOrigin: { vertical: "top", horizontal: "left" },
                                                PaperProps: { className: styles.modifyTemplate__selectMenu, style: { maxHeight: 250, maxWidth: 140 } },
                                            }}
                                        >
                                            {whatsappTemplateLanguages?.map((option: any, ind: number) => (
                                                <MenuItem value={option.whatsapp_language_id} key={ind}
                                                    sx={{
                                                        fontSize: '13px',
                                                        whiteSpace: 'normal',
                                                        wordBreak: 'break-word',
                                                    }}
                                                >
                                                    {option?.whatsapp_language_name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                </>
                            )}

                        </Grid>

                        {!isScreenBelow1000 && (
                            <Divider orientation="vertical" flexItem className={styles.modifyTemplate__headerDivider} />
                        )}

                        {!isScreenBelow1250 ? (
                            <>
                                <Grid item display="flex" justifyContent="flex-start" alignItems="center" flexWrap="nowrap" gap={1} 
                                    className={styles.modifyTemplate__saveButton}
                                >
                                    {!template_id && (
                                        <GlobalButton
                                            buttonText={
                                                isSavingDraft ? (
                                                    <span className={styles.modifyTemplate__saveDraftButtonContent}>
                                                        <CircularProgress size={14} color="inherit" />
                                                        Save Draft
                                                    </span>
                                                ) : "Save Draft"
                                            }
                                            className="borderedButtonStyle"
                                            onClick={() => handleSaveDraft()}
                                            disabled={!!template_id || isSavingDraft}
                                        />
                                    )}

                                    {headerCreateButton}
                                </Grid>

                                <Divider orientation="vertical" flexItem className={styles.modifyTemplate__headerDivider} />

                                <Grid item display="flex" alignItems="center" justifyContent="flex-start" flexWrap="nowrap" gap={0.5} 
                                    className={styles.modifyTemplate__saveButton}
                                >
                                    {headerFormToggle}

                                    {!template_id && (
                                        headerMenuTrigger
                                    )}
                                </Grid>
                            </>
                        ) : (
                            <Grid item display="flex" alignItems="center" justifyContent="flex-start" flexWrap="nowrap" gap={0.5} 
                                className={styles.modifyTemplate__saveButton}
                            >
                                {headerCreateButton}

                                <div className={styles.modifyTemplate__headerIconGroup}>
                                    {headerFormToggle}

                                    {!template_id && (
                                        headerMenuTrigger
                                    )}
                                </div>
                            </Grid>
                        )}

                        <Menu
                            anchorEl={anchorEl as HTMLElement}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                        >
                            {menuItems?.map((item, index) => (
                                <MenuItem
                                    className={`
                                        ${globalStyles.menuItemStyle} 
                                        ${isScreenBelow1250 ? styles.modifyTemplate__headerMenuItem : globalStyles.secondaryFontSize} 
                                        ${isCreateMenuItemActive(item?.templateType) ? styles.modifyTemplate__menuItemActive : ""}
                                    `}
                                    key={index}
                                    disabled={!!item?.disable}
                                    onClick={() => { handleMenuClick(item?.action); }}
                                >
                                    <span>{item?.label}</span>
                                </MenuItem>
                            ))}
                        </Menu>

                    </Grid>

                </Grid>
            </Grid>

            {(hasUnsavedChanges && showUnsavedChangesModal) && (
                <GlobalPopUp
                    open={true}
                    paperMinWidth={popupPaperMinWidth}
                    paperMaxwidth={popupPaperMaxWidth}
                    flagShowCloseIcon={true}
                    onClose={() => closeUnsavedChangesModal()}
                    handleClose={() => closeUnsavedChangesModal()}
                    overflow="hidden"
                    titlePadding='0px'
                >
                    <UnsavedChangesPopup
                        closeUnsavedChangesModal={closeUnsavedChangesModal}
                        confirmSaveAndLeave={confirmSaveAndLeave}
                        confirmLeavePage={confirmLeavePage}
                    />
                </GlobalPopUp>
            )}

            {showConnectWabaModal && (
                <GlobalPopUp
                    open={showConnectWabaModal}
                    paperMinWidth={popupPaperMinWidth}
                    paperMaxwidth={popupPaperMaxWidth}
                    flagShowCloseIcon={true}
                    onClose={() => setShowConnectWabaModal(false)}
                    handleClose={() => setShowConnectWabaModal(false)}
                    overflow="hidden"
                    titlePadding='0px'
                >
                    <ConnectWabaPopup />
                </GlobalPopUp>
            )}

            {showImportTemplatePopup && (
                <GlobalPopUp
                    open={showImportTemplatePopup}
                    onClose={() => { setShowImportTemplatePopup(false); }}
                    handleClose={() => { setShowImportTemplatePopup(false); }}
                    flagBackdrop
                    flagShowCloseIcon={true}
                    paperMinWidth={isCompactPopup ? "310px" : "650px"}
                    paperMaxwidth={isCompactPopup ? "610px" : "700px"}
                    titlePadding='0px'
                >
                    <ImportTemplatePopup
                        title='Import Template'
                        handleClose={() => setShowImportTemplatePopup(false)}
                        flagShowCreateTemplateButtons={false}
                        flagIsLegacyTemplate={false}
                    />
                </GlobalPopUp>
            )}

            {postCreatePopup && (
                <GlobalPopUp
                    open={true}
                    paperMinWidth={popupPaperMinWidth}
                    paperMaxwidth={popupPaperMaxWidth}
                    flagShowCloseIcon={true}
                    onClose={closePostSubmitPopup}
                    handleClose={closePostSubmitPopup}
                    overflow="hidden"
                    titlePadding='0px'
                >
                    <PostCreateTemplatePopup />
                </GlobalPopUp>
            )}
        </>
    );

}

export default ModifyWhatsAppTemplateHeader;
